<template>
  <div class="newHeader">
    <header class="inner">
      <div class="left fl">
        <span class="wBox gfBox fl">
          官方微信
          <div class="codeBox">
            <p class="txt">打开微信扫一扫</p>
            <img class="wjw" :src="wximg" alt="">
          </div>
        </span>
        <!-- <a class="wBox fl wb"  href="http://weibo.com/2154995337" target="_blank">
          官方微博
        </a> -->
        <a :href="navsObj.site.app_link" target="_blank" v-if="navsObj.site.app_link" class="wBox fl phone">客户端</a>
        <span class="wBox gfBox xcx fl" v-if="navsObj.site.mini_app_image">
          小程序
          <div class="codeBox">
            <p class="txt">打开微信扫一扫</p>
            <img class="wjw" :src="navsObj.site.mini_app_image" alt="">
          </div>
        </span>
        <span class="wBox gfBox ggBox fl" v-if="navsObj.site.ad_contact">
          广告联系
          <div class="codeBox phoneBox">
            <p class="txt">广告投放电话</p>
            <a class="phone2" :href='navsObj.site.ad_contact'>{{navsObj.site.ad_contact}}</a>
          </div>
        </span>
      </div>
      <div class="right fr">
        <div v-if="areaUserInfo">
          <span>您好，{{areaUserInfo.username?areaUserInfo.username:'邻友'}} | </span>
          <!-- <a :href="loginUrls.pm_url" target="_blank">短信息 | </a>
          <a :href="loginUrls.setting_url" target="_blank">设置 | </a>
          <a :href="loginUrls.notice_url" target="_blank">提醒 | </a> -->
          <a href="javascript:;" @click="signOut">退出</a>
        </div>
        <a v-else href="javascript:;" class="loginBtn" @click="login">登录</a>
      </div>
    </header>
  </div>
</template>
<script>

import { storageData } from "@/assets/js/storage";
export default {
  props:['wximg','navsObj','loginUrls','myuserInfo'],
  data() {
    return {
      areaUserInfo:{
        avatar: "",
        username: "",
        fansNum: "",
        followNum: "",
      },
    }
  },
  mounted() {
    // if(this.navsObj.site.id==1) {
    //   this.userInfo = this.myuserInfo
    // }else{
    //   this.userInfo = storageData.getUserInfo()
    // }
    this.areaUserInfo = storageData.getUserInfo()
    // console.log(storageData.getUserInfo())
  },
  methods:{
    login() {
      // 望京
      // if(this.navsObj.site.id==1) {
      //   let url = `${this.loginUrls.login_url}&referer=${encodeURIComponent(window.location.href)}`
      //   window.location.href = url
      // }else{
        this.$router.push({ path: "/arealogin" });
      // }
    },
    // 退出
    signOut() {
      storageData.clearToken();
      // storageData.clearUserInfo();
      localStorage.removeItem('loginUserInfo');
      // this.delCookie("accessToken");
      // if(this.navsObj.site.id==1) {
      //   let url = `${this.loginUrls.login_out}${encodeURIComponent(window.location.href)}`
      //   window.location.href = url
      // }else{
        this.$router.go(0)
        this.$router.push({ path: "/"});
      // }
    }
  }
}
</script>
<style lang="less">
.loginsuccess{
  top: 15px;
  position: absolute;
  right: 414px;
}
@import '~@/assets/less/index.less';
.newHeader{
  width: 100%;
  box-shadow:0 1px 5px 0 rgba(0,0,0,0.20);
  line-height: 50px;
  height: 50px;
  header{
    .left{
      .wBox{
        position: relative;
        cursor: pointer;
        margin:0 30px 0 0;
        padding:0 0 0 29px;
        background: url('~@/assets/imgs/wc.png') no-repeat left center;
        color:@c6;
        height: 100%;
        display: inline-block;
        font-size:@ft14;
        &:hover{
          text-decoration: underline;
        }
        &.wb{
          background-image: url('~@/assets/imgs/wbb.png');
        }
        &.xcx{
          background-image: url('~@/assets/imgs/xcx.png');
        }
        &.ggBox{
          background-image: url('~@/assets/imgs/p2.png');
        }
        &.phone{
          background-image: url('~@/assets/imgs/phone.png');
        }
        .phone2{
          line-height: 1;
          font-size: 18px;
          font-weight: bold;
          color: #000;
        }
        &.gfBox{
          &:hover{
            .codeBox{
              display: block;
            }
          }
        }
        .codeBox{
          width: 158px;
          height: 158px;
          z-index: 99;
          background: #fff;
          position: absolute;
          text-align: center;
          padding: 10px 0;
          left:0;
          display: none;
          box-shadow: 0 1px 5px 0 rgba(0,0,0,0.2);
          &.phoneBox{
            padding:40px 0 -10px;
            height: 78px;
            .txt{
              line-height: 20px;
              margin-bottom:0;
            }
          }
          .wjw{
            width:115px;
            height: 115px;
          }
          .txt{
            line-height: 0;
            color: #666;
            margin-bottom: 15px;
          }
        }
      }
    }
    .right{
      .loginBtn{
        font-size:@ft14;
        color:#d51938;
        border:1px solid #d51938;
        border-radius:3px;
        width: 52px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        display: inline-block;
      }
      a,span{
        font-size:@ft14;
        color:@c6;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/top.vue